import React, { memo, useMemo } from "react";
import Drawer from "@mui/material/Drawer";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { sidebarMenuExpanded, sidebarOpened, setSidebarMenuExpanded, useStore } from "../../helpers";
import SidebarToggle from "./SidebarToggle";
const sxStyles = ({ spacing, palette, transitions }) => {
    const transitionEntering = {
        duration: transitions.duration.enteringScreen,
        delay: transitions.duration.shortest,
    };
    const transitionLeaving = {
        duration: transitions.duration.leavingScreen,
        delay: transitions.duration.shortest,
    };
    return {
        root: {
            width: spacing(6),
            transition: transitions.create(["width"], transitionLeaving),
        },
        paper: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            width: spacing(6),
            paddingTop: spacing(6 + 3), // CPHeader + standard spacing
            overflow: "hidden",
            border: "0 none",
            backgroundColor: palette.primary.main,
            color: palette.primary.contrastText,
            transition: transitions.create(["width"], transitionLeaving),
        },
        expanded: {
            width: spacing(27),
            transition: transitions.create(["width"], transitionEntering),
        },
    };
};
const Sidebar = ({ children, showCollapseButton = true, sx }) => {
    const isSidebarOpened = useStore(sidebarOpened);
    const isMenuExpanded = useStore(sidebarMenuExpanded);
    const { breakpoints } = useTheme();
    const isLargeScreen = useMediaQuery(breakpoints.up("xl"));
    const isExpanded = useMemo(() => {
        if (!isSidebarOpened && isLargeScreen && !isMenuExpanded) {
            return false;
        }
        if ((isLargeScreen && isMenuExpanded) || isLargeScreen) {
            return true;
        }
        return isMenuExpanded;
    }, [isMenuExpanded, isLargeScreen, isSidebarOpened]);
    const handleOpen = () => {
        setSidebarMenuExpanded(true);
    };
    const handleClose = () => {
        setSidebarMenuExpanded(false);
    };
    return (React.createElement(Drawer, { variant: "permanent", sx: (theme) => ({
            "&.MuiDrawer-root": {
                ...sxStyles(theme).root,
                ...(isExpanded && sxStyles(theme).expanded),
                ...sx?.root,
            },
            "& .MuiDrawer-paper": {
                ...sxStyles(theme).paper,
                ...(isExpanded && sxStyles(theme).expanded),
                ...sx?.paper,
            },
        }), elevation: 2, onMouseOver: handleOpen, onMouseLeave: handleClose, hideBackdrop: true, open: true },
        showCollapseButton && React.createElement(SidebarToggle, null),
        children));
};
export default memo(Sidebar);
//# sourceMappingURL=Sidebar.js.map